<template>
  <div class="certification-list-item-conditionals">
    <div class="certification-list-item-conditionals__required-flag">
      <div class="certification-list-item-conditionals__required-flag-icon ignore-tooltip">
        <NotificationIcon
          class="certification-list-item-conditionals__required-flag-icon-svg"
          v-tooltip="{
            content: notificationMsg,
            placement: 'top',
            classes: ['tooltip__text-centered', 'tooltip__text-max-width'],
          }"
        />
      </div>
      <div class="certification-list-item-conditionals__required-flag-text">
        Subscription required
      </div>
    </div>
    <div class="certification-list-item-conditionals__content">
      <div v-if="!isAuthenticated" class="certification-list-item-conditionals__no-auth">
        Already subscribed?
        <span
          class="certification-list-item-conditionals__content-cta ignore-tooltip"
          @click="handleOpenModal"
        >
          Sign in
        </span>
        <span>to your account</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import NotificationIcon from '@/assets/icons/notification.svg'
import CONSTANTS from '@/constants'

const { PLANS, PREMIUM_PLANS, VOUCHERS_TOOLTIP } = CONSTANTS

export default {
  name: 'CertificationListItemConditionals',
  components: {
    NotificationIcon: { ...NotificationIcon, name: 'NotificationIcon' },
  },
  data() {
    return {
      myIneDashboardLink: `//${process.env.VUE_APP_STREAMING_URL}/dashboard/subscriptions`,
      notificationMsg: VOUCHERS_TOOLTIP,
    }
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
      usersCurrentSubscriptions: 'subscriptions/getUsersCurrentSubscriptions',
    }),
    userHasSubcription() {
      return this.usersCurrentSubscriptions.length > 0
    },
    userHasFundamentalsOrPremiumSubscription() {
      const userHasFundamentals = !!this.usersCurrentSubscriptions.some(subscription =>
        [...Object.values(PREMIUM_PLANS), PLANS.ANNUAL].includes(subscription.plan_code)
      )
      return this.usersCurrentSubscriptions.length > 0 && userHasFundamentals
    },
  },
  methods: {
    ...mapActions({
      setIsSignInModalShown: 'app/setIsSignInModalShown',
    }),
    handleOpenModal() {
      this.setIsSignInModalShown(true)
    },
  },
}
</script>

<style scoped lang="scss">
.certification-list-item-conditionals {
  grid-area: 3 / 1 / 3 / 4;
  align-self: flex-end;
  padding-top: 20px;
  display: flex;
  align-items: center;
  position: relative;
  left: -40px;
  gap: 10px;

  &__required-flag {
    display: flex;
    padding: 6px 10px;
    justify-content: flex-start;
    align-items: unset;
    gap: 5px;
    background: var(
      --Glass-Extra-Light,
      linear-gradient(112deg, rgba(187, 188, 199, 0.4) -46.39%, rgba(187, 188, 199, 0) 112.38%)
    );
    clip-path: polygon(0 0, 100% 0, 97% 100%, 0% 100%);
    max-width: 165px;
    &-icon {
      display: flex;
      &-svg {
        width: 16px;
      }
    }

    &-text {
      color: var(--white, #fff);
      text-align: center;
      font-feature-settings: 'liga' off, 'clig' off;

      font-size: rem(12px);
      font-style: normal;
      font-weight: 450;
      line-height: rem(14px);
      white-space: nowrap;
    }
  }

  &__content {
    color: var(--white, #fff);
    font-feature-settings: 'liga' off, 'clig' off;
    font-size: rem(12px);
    font-style: normal;
    font-weight: 450;
    line-height: rem(14px);
    &-cta {
      color: var(--purple-pale, #c9bbff);
      font-feature-settings: 'liga' off, 'clig' off;
      font-size: 12px;
      font-style: normal;
      font-weight: 450;
      line-height: 14px;
      text-decoration: none;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>
